document.addEventListener('DOMContentLoaded', () => {
  const sideCart = document.getElementById('side-cart');
  const sideCartContent = document.getElementById('side-cart-content');

  if (!sideCart || !sideCartContent) return;

  const sideCartPanel = sideCart.querySelector('.side-cart__panel');
  const closeButton = sideCart.querySelector('.side-cart__close');

  /* -----------------------------------------
                  ABRIR / CERRAR
  ------------------------------------------*/
  function openSideCart() {
    sideCart.classList.add('side-cart--open');
    sideCart.style.visibility = 'visible';
    sideCart.style.opacity = '1';
  }

  function closeSideCart() {
    sideCart.classList.remove('side-cart--open');
    sideCart.style.opacity = '0';
    setTimeout(() => {
      sideCart.style.visibility = 'hidden';
    }, 300);
  }

  /* -----------------------------------------
             CERRAR CON BOTÓN ❌
  ------------------------------------------*/
  if (closeButton) {
    closeButton.addEventListener('click', (e) => {
      e.preventDefault();
      closeSideCart();
    });
  }

  /* -----------------------------------------
     CERRAR AL HACER CLIC FUERA DEL PANEL
  ------------------------------------------*/
  document.addEventListener('click', (e) => {
    if (!sideCart.classList.contains('side-cart--open')) return;
    if (sideCartPanel && sideCartPanel.contains(e.target)) return;
    if (e.target.closest('.product-card')) return;
    closeSideCart();
  });

  /* -----------------------------------------
             ACTUALIZAR CARRITO (CORE)
  ------------------------------------------*/
  async function updateSideCart() {
    try {
      const sections = [
        'template--17053462790197__cart-items',
        'template--17053462790197__cart-footer'
      ];

      const url =
        window.Shopify.routes.root +
        `?sections=${sections.join(',')}`;

      const res = await fetch(url);
      if (!res.ok) console.error('Error trayendo secciones');

      const data = await res.json();

      sideCartContent.innerHTML = `
        <div class="sidecart-inner">
          <div class="sidecart-items">
            ${data['template--17053462790197__cart-items']}
          </div>

          <div class="sidecart-footer">
            ${data['template--17053462790197__cart-footer']}
          </div>
        </div>
      `;

      const btnCheckout = sideCartContent.querySelector('.sidecart-checkout-btn');
      if (btnCheckout) {
        btnCheckout.addEventListener('click', () => {
          window.location.href = '/checkout';
        });
      }

      bindQuantityUpdates();
      bindRemoveButtons();

      openSideCart();
    } catch (err) {
      console.error('Error updateSideCart():', err);
    }
  }

  /* -----------------------------------------
             CAMBIAR CANTIDAD
  ------------------------------------------*/
  function bindQuantityUpdates() {
    const inputs = sideCart.querySelectorAll('input[name="updates[]"]');

    inputs.forEach((input) => {
      input.addEventListener('change', async () => {
        const qty = Number(input.value);
        if (!Number.isFinite(qty)) return;

        const key = input.dataset.cartItemKey;
        const line = input.dataset.index;

        const payload = key
          ? { id: key, quantity: qty }
          : { line: Number(line), quantity: qty };

        await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });

        updateSideCart();
      });
    });
  }

  /* -----------------------------------------
                ELIMINAR ITEM
  ------------------------------------------*/
  function bindRemoveButtons() {
    const removeBtns = sideCart.querySelectorAll('a[href*="quantity=0"]');

    removeBtns.forEach((btn) => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();

        const key = new URL(btn.href).searchParams.get('id');

        await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 }),
        });

        updateSideCart();
      });
    });
  }

  /* -----------------------------------------
              AÑADIR DESDE LAS CARDS
  ------------------------------------------*/
  function bindProductCards() {
    const cards = document.querySelectorAll('.product-card');

    cards.forEach((card) => {
      const variantId = card.dataset.variantId;

      card.addEventListener('click', (e) => {
        // si se hace clic en "Ver más", no abrir side cart
        if (e.target.closest('.buttona')) return;

        e.preventDefault();
        e.stopPropagation();

        addToCart(variantId);
      });
    });
  }

  /* -----------------------------------------
                  AJAX ADD
  ------------------------------------------*/
  async function addToCart(variantId) {
    await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
    });

    updateSideCart();
  }

  /* 🟣 NUEVO: API GLOBAL PARA OTRAS SECCIONES */
  window.HypatiaSideCart = {
    addToCart,
    updateSideCart,
    openSideCart,
    closeSideCart
  };

  /* LOAD INITIAL BINDS PARA LAS .product-card */
  bindProductCards();
});
